import { Calendar as CoreCalendar, CalendarProps as CoreCalendarProps, makeClassName } from "@hex-insights/core";
import "./styles.css";

export type CalendarProps = CoreCalendarProps;

export function Calendar({ className, ...props }: CalendarProps) {
	return <CoreCalendar className={makeClassName("verita-calendar", className)} {...props} />;
}
